import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import LignePanel from './LignePanel';
import CodeProduitLocalComponent from '../../../components/Mouvement/Panel/CodeProduitLocalComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';

class CodeProduitLocalPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.CODE_PRODUIT_LOCAL;
    this.icon = { name: 'compass outline' };
  }

  getLibelle = () => 'Code produit local';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.identifiantCodprodloc);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <CodeProduitLocalComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default CodeProduitLocalPanel;
